import { RenderChannelModel, RenderPlayerModel, RenderPostStatistic, RenderTemplateModel } from "./types";
import { TimeZone } from "@/services/timeZones/types";
import { FolderPost } from "@/services/posts/postTypes/folder";
import { Solution } from "@/services/solutions/types";
import api from "@/services/api";
import { WayfinderRenderModel } from "../wayfinder/types";

export async function renderChannel(
    channelId: string,
    dateTime: string
): Promise<RenderChannelModel> {
    return new Promise((resolve, reject) => {
        api.post(`/render/channel/${channelId}`,
            { dateTime: dateTime }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function renderChannelGroup(
    channelGroupId: string,
    dateTime: string): Promise<RenderChannelModel> {
    return new Promise((resolve, reject) => {
        api.post(`/render/channelGroup/${channelGroupId}`,
            { dateTime: dateTime }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function renderBackground(
    backgroundId: string,
    dateTime: string
): Promise<RenderTemplateModel> {
    return new Promise((resolve, reject) => {
        api.post(`/render/background/${backgroundId}`,
            { dateTime: dateTime }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function renderTemplate(
    templateId: string,
    dateTime: string
): Promise<RenderTemplateModel> {
    return new Promise((resolve, reject) => {
        api.post(`/render/template/${templateId}`,
            { dateTime: dateTime }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function renderPlayer(
    playerId: string,
    preview = false
): Promise<RenderPlayerModel> {
    return new Promise((resolve, reject) => {
        api.get(`/render/player/${playerId}${preview ? "/preview" : ""}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getTimeZones(): Promise<TimeZone[]> {
    return new Promise((resolve, reject) => {
        api.get(`/render/timeZones`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getSolution(id: string): Promise<Solution> {
    return new Promise((resolve, reject) => {
        api.get(`/render/solution/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getWayfinderRender(id: number): Promise<Array<WayfinderRenderModel>> {
    return new Promise((resolve, reject) => {
        api.get(`/render/wayfinder/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function saveStatistics(statistics: RenderPostStatistic[]): Promise<any> {
    return new Promise((resolve, reject) => {
        api.post(`/renderStatistics`, statistics).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export function calculateMediaContentDimensions(
    contentWidth: number,
    contentHeight: number,
    maxWidth: number,
    maxHeight: number
) {
    if (contentWidth > maxWidth || contentHeight > maxHeight) {
        const ratio = Math.min(maxWidth / contentWidth, maxHeight / contentHeight);
        return { width: contentWidth * ratio, height: contentHeight * ratio };
    } else {
        return { width: contentWidth, height: contentHeight };
    }
}
